import gql from "../gql";
import SearchResultConnection from "../fragments/SearchResultConnection";
export default gql `
  query Search(
    $first: Int = 15
    $after: String
    $searchInput: SearchInput!
    $filter: SearchFilterInput
    $searchAnalyticsPayload: String
  ) {
    search(
      first: $first
      after: $after
      criteria: $searchInput
      filter: $filter
      searchAnalyticsPayload: $searchAnalyticsPayload
    ) {
      ...SearchResultConnection
    }
  }
  ${SearchResultConnection}
`;
